const useBulkUtils = () => {
  const cancelBulkMode = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete("mode");
    window.location.href = url.toString();
  };

  const toggleBulkSelected = (selectedIds, id) => {
    const newSet = new Set(selectedIds);
    newSet.has(id) ? newSet.delete(id) : newSet.add(id);
    return newSet;
  };

  return {
    cancelBulkMode,
    toggleBulkSelected,
  };
};

export default useBulkUtils;
